export const OnlineGPConsultationsTitle = "medical.information.onlineGPconsultations.title"

export const PrescriptionServiceTitle = "medical.information.prescriptionService.title"

export const OnlineGPConsultations = {
  title: OnlineGPConsultationsTitle,
  points: [
    {emoji: "iphone", text: "medical.information.onlineGPconsultations.points.1"},
    {emoji: "spiral_calendar_pad", text: "medical.information.onlineGPconsultations.points.2"},
    {emoji: "hourglass", text: "medical.information.onlineGPconsultations.points.3"},
    {emoji: "selfie", text: "medical.information.onlineGPconsultations.points.4"},
    {emoji: "female-doctor", text: "medical.information.onlineGPconsultations.points.5"},
    {emoji: "dca", text: "medical.information.onlineGPconsultations.points.6", isIcon: true}
  ],
  terms: "medical.information.onlineGPconsultations.terms"
}

export const PrescriptionService = {
  title: PrescriptionServiceTitle,
  points: [
    {emoji: "pencil", text: "medical.information.prescriptionService.points.1"},
    {emoji: "pill", text: "medical.information.prescriptionService.points.2"},
    {emoji: "mailbox", text: "medical.information.prescriptionService.points.3"},
    {emoji: "repeat", text: "medical.information.prescriptionService.points.4"},
    {emoji: "package", text: "medical.information.prescriptionService.points.5"}
  ],
  terms: "medical.information.prescriptionService.terms"
}

export const DiagnosticInvestigations = {
  title: "medical.information.diagnosticInvestigations.title",
  desc: ["medical.information.diagnosticInvestigations.desc.1"],
  points: [
    {emoji: "male-doctor", text: "medical.information.diagnosticInvestigations.points.1"},
    {emoji: "syringe", text: "medical.information.diagnosticInvestigations.points.2"},
    {emoji: "pager", text: "medical.information.diagnosticInvestigations.points.3"}
  ]
}

export const Physiotherapy = {
  title: "medical.information.physiotherapy.title",
  desc: ["medical.information.physiotherapy.desc.1"],
  points: [{emoji: "runner", text: "medical.information.physiotherapy.points.1"}]
}

export const Tier1Info = [OnlineGPConsultations, PrescriptionService]

export const Tier2Info = [
  OnlineGPConsultations,
  PrescriptionService,
  {...DiagnosticInvestigations, limits: "medical.information.diagnosticInvestigations.limits.1", terms: "medical.information.terms.2"},
  {
    ...Physiotherapy,
    limits: "medical.information.physiotherapy.limits.1",
    terms: "medical.information.terms.2"
  }
]

export const Tier3Info = [
  OnlineGPConsultations,
  PrescriptionService,
  {...DiagnosticInvestigations, limits: "medical.information.global.limits.fullRefund"},
  {
    ...Physiotherapy,
    limits: "medical.information.physiotherapy.limits.2"
  },
  {
    title: "medical.information.specialists.title",
    desc: ["medical.information.global.inpatient"],
    points: [{emoji: "female-doctor", text: "medical.information.specialists.points.1"}],
    limits: "medical.information.global.limits.fullRefund"
  },
  {
    title: "medical.information.hospitalCharges.title",
    desc: ["medical.information.global.inpatient", "medical.information.global.outpatient"],
    points: [
      {emoji: "pill", text: "medical.information.hospitalCharges.points.1"},
      {emoji: "hospital", text: "medical.information.hospitalCharges.points.2"}
    ],
    limits: "medical.information.global.limits.fullRefund"
  },
  {
    title: "medical.information.homeNursing.title",
    desc: ["medical.information.global.inpatient"],
    points: [{emoji: "house", text: "medical.information.homeNursing.points.1"}],
    limits: "medical.information.global.limits.fullRefund"
  },
  {
    title: "medical.information.NHScashBenefit.title",
    points: [{emoji: "bed", text: "medical.information.NHScashBenefit.points.1"}],
    limits: "medical.information.NHScashBenefit.limits"
  },
  {
    title: "medical.information.mentalHealthCounselling.title",
    points: [
      {emoji: "iphone", text: "medical.information.mentalHealthCounselling.points.1"},
      {emoji: "busts_in_silhouette", text: "medical.information.mentalHealthCounselling.points.2"}
    ],
    limits: "medical.information.mentalHealthCounselling.limits"
  }
]
